export default "__VITE_ASSET__D8oeS63x__"